import { Box, Button, Paper, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { SendEmailIcon } from '../../../../components/icons'

export const SignUpSuccess = () => {
  const navigate = useNavigate()

  return (
    <Box display="flex" justifyContent="center" alignItems="center" minHeight="75vh">
      <Box maxWidth="450px" bgcolor="#FFFFFF">
        <Paper
          elevation={0}
          sx={{
            p: 6,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            height: '450px',
            alignItems: 'center',
          }}
        >
          <SendEmailIcon color="success" sx={{ fontSize: 100 }} />

          <Typography component="h1" variant="h5" sx={{ mt: 2, mb: 1 }}>
            Success
          </Typography>
          <Typography variant="body2" sx={{ mt: 4, textAlign: 'center' }}>
            You have successfully created an account with Grant Match. To continue, please click on
            the button below to navigate to the login page.
          </Typography>

          <Button
            sx={{ my: 2, fontSize: '0.875rem', textTransform: 'none' }}
            onClick={() => navigate('/login')}
          >
            To Login
          </Button>
        </Paper>
      </Box>
    </Box>
  )
}
